/**
 * @fileoverview Firm Contacts layout
 *
 * URL: /dashboard/firm-contacts/*
 *
 * Thin layout wrapper for the firm-contacts area. Two child pages share the
 * sidebar group: the directory (index) and the contact-fields manager.
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/firm-contacts",
)({
  component: () => <Outlet />,
  beforeLoad: () => ({
    headerTitle: "Firm Contacts",
  }),
});
